import apiService from '../../../apiService'

export default {
  namespaced: true,
  state: {
    service: '',
    phone: '',
    ordering: [],
    ordered: []
  },
  mutations: {
    setService (state, payload) {
      state.service = payload
    },
    setPhone (state, payload) {
      state.phone = payload
    },
    removeOrdering (state, service) {
      state.ordering = state.ordering.filter(i => i !== service)
    }
  },
  actions: {
    send ({ state, commit }, { domain, phone, service }) {
      state.ordering.push(service)

      return new Promise((resolve, reject) => {
        apiService.postFormsServiceOrder(domain, phone, service)
          .then(response => {
            state.ordered.push(service)
            commit('removeOrdering', service)

            resolve(response.data)
          })
          .catch(error => {
            commit('removeOrdering', service)

            reject(error)
          })
      })
    }
  },
  getters: {
    isOrdering: state => service => state.ordering.includes(service),
    isOrdered: state => service => state.ordered.includes(service)
  }
}
